import { render, staticRenderFns } from "./PaglieraniTask.vue?vue&type=template&id=0b3ced1a&scoped=true&"
import script from "./PaglieraniTask.vue?vue&type=script&lang=js&"
export * from "./PaglieraniTask.vue?vue&type=script&lang=js&"
import style0 from "./PaglieraniTask.vue?vue&type=style&index=0&id=0b3ced1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3ced1a",
  null
  
)

export default component.exports